import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    level: null, // 当前流程等级
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
